/**
 * Poetry Gallery — Echords
 * Tab filtering + Lightbox
 */
(function () {
  'use strict';

  /* ---------- Tab Filtering ---------- */

  function initTabs() {
    var tabContainer = document.querySelector('.poetry-gallery__tabs');
    if (!tabContainer) return;

    var tabs = tabContainer.querySelectorAll('.poetry-gallery__tab');
    var cards = document.querySelectorAll('.poetry-card');
    var tagline = document.querySelector('.poetry-gallery__tagline');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var season = tab.getAttribute('data-season');

        // Update active tab
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        // Update tagline
        if (tagline) {
          tagline.textContent = tab.getAttribute('data-tagline') || '';
        }

        // Filter cards
        cards.forEach(function (card) {
          if (season === 'all' || card.getAttribute('data-season') === season) {
            card.removeAttribute('data-status');
          } else {
            card.setAttribute('data-status', 'hidden');
          }
        });
      });
    });
  }

  /* ---------- Lightbox ---------- */

  var lightbox = null;
  var currentCards = [];
  var currentIndex = 0;

  function initLightbox() {
    lightbox = document.querySelector('.poetry-lightbox');
    if (!lightbox) return;

    var cards = document.querySelectorAll('.poetry-card');
    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        openLightbox(card);
      });
    });

    // Close handlers
    var closeBtn = lightbox.querySelector('.poetry-lightbox__close');
    var backdrop = lightbox.querySelector('.poetry-lightbox__backdrop');

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (backdrop) backdrop.addEventListener('click', closeLightbox);

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigateLightbox(-1);
      if (e.key === 'ArrowRight') navigateLightbox(1);
    });

    // Nav buttons
    var prevBtn = lightbox.querySelector('[data-nav="prev"]');
    var nextBtn = lightbox.querySelector('[data-nav="next"]');
    if (prevBtn) prevBtn.addEventListener('click', function () { navigateLightbox(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { navigateLightbox(1); });
  }

  function getVisibleCards() {
    return Array.from(document.querySelectorAll('.poetry-card:not([data-status="hidden"])'));
  }

  function openLightbox(card) {
    if (!lightbox) return;

    currentCards = getVisibleCards();
    currentIndex = currentCards.indexOf(card);
    if (currentIndex === -1) currentIndex = 0;

    populateLightbox(card);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function navigateLightbox(direction) {
    var newIndex = currentIndex + direction;
    if (newIndex < 0 || newIndex >= currentCards.length) return;
    currentIndex = newIndex;
    populateLightbox(currentCards[currentIndex]);
  }

  function populateLightbox(card) {
    if (!lightbox || !card) return;

    var data = card.dataset;

    // Painting
    var paintingSrc = data.paintingSrc || '';
    var paintingEl = lightbox.querySelector('.poetry-lightbox__painting img');
    if (paintingEl) paintingEl.src = paintingSrc;

    // Text content
    setText('.poetry-lightbox__number', 'No. ' + padNumber(currentIndex + 1));
    setText('.poetry-lightbox__season', data.seasonLabel || '');
    setText('.poetry-lightbox__title', data.poemTitle || '');

    // Poems
    setHTML('.poetry-lightbox__poem-en', data.poemEn || '');
    setHTML('.poetry-lightbox__poem-cn', data.poemCn || '');

    // Story
    var storyEl = lightbox.querySelector('.poetry-lightbox__story');
    var storyLabelEl = lightbox.querySelector('.poetry-lightbox__story-label');
    if (data.story) {
      setHTML('.poetry-lightbox__story', data.story);
      if (storyEl) storyEl.style.display = '';
      if (storyLabelEl) storyLabelEl.style.display = '';
    } else {
      if (storyEl) storyEl.style.display = 'none';
      if (storyLabelEl) storyLabelEl.style.display = 'none';
    }

    // CTA
    var ctaEl = lightbox.querySelector('.poetry-lightbox__cta');
    if (ctaEl) {
      var isActive = data.seasonStatus === 'active';
      ctaEl.href = data.ctaUrl || '#';
      ctaEl.textContent = isActive ? 'Shop Original Art Print →' : 'Notify Me 🔔';
      ctaEl.className = 'poetry-lightbox__cta' + (isActive ? '' : ' poetry-lightbox__cta--notify');
    }

    // Nav buttons
    var prevBtn = lightbox.querySelector('[data-nav="prev"]');
    var nextBtn = lightbox.querySelector('[data-nav="next"]');
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === currentCards.length - 1;
  }

  function setText(selector, text) {
    var el = lightbox.querySelector(selector);
    if (el) el.textContent = text;
  }

  function setHTML(selector, html) {
    var el = lightbox.querySelector(selector);
    if (el) el.innerHTML = html;
  }

  function padNumber(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /* ---------- Init ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    initTabs();
    initLightbox();
  });
})();
